import { Menu, MenuItem, Popover } from '@blueprintjs/core';
import { lock_hooks } from '@axo/shared/data-access/hooks';
import { IconButton } from '../IconButton';
import styles from './Navigation.module.css';
import { useCloseApplication } from '../../hooks/navigation/useCloseApplication';

export function Locks({ marketCountry }: { marketCountry: string }) {
  const locked = lock_hooks.useCurrentUserLocks(marketCountry);
  const { closeAndUnlockMultiple } = useCloseApplication(marketCountry);

  return (
    <Popover
      interactionKind="hover"
      position="bottom"
      popoverClassName="bp5-tooltipTooltip"
      content={
        <Menu className={styles.lockMenu}>
          <MenuItem
            icon="unlock"
            text="Release all my locks"
            disabled={!locked.data?.Items}
            onClick={async () => {
              const ids = (locked.data?.Items ?? []).map(
                (x) => x.LoanApplicationID
              );
              await closeAndUnlockMultiple(ids);
            }}
          />
        </Menu>
      }
    >
      <IconButton icon="lock" />
    </Popover>
  );
}
